import { createContext, useContext } from 'react';

export type FormItemContextValue = { id: string; name: string };

export const FormItemContext = createContext<FormItemContextValue | null>(null);

export function useFormItem(): FormItemContextValue {
  const value = useContext(FormItemContext);
  if (!value) throw new Error('Form parts must sit inside <FormField> and <FormItem>');
  return value;
}
